import { FC } from "react";

export const WebflowReplace: FC = () => {
  const { pathname, origin } = window.location;

  const url = `${origin}${pathname}`;
  window.location.replace(url);

  return null;
};
